import { render, staticRenderFns } from "./aiAbility.vue?vue&type=template&id=61d87e9a&scoped=true"
import script from "./aiAbility.vue?vue&type=script&lang=js"
export * from "./aiAbility.vue?vue&type=script&lang=js"
import style0 from "./aiAbility.vue?vue&type=style&index=0&id=61d87e9a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_f33b182414a87044fb4ff91041025cb4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d87e9a",
  null
  
)

export default component.exports